var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.6354L9.00938 19.626C8.12939 20.5058 6.93601 21 5.69168 21C4.44735 21 3.25397 20.5058 2.37398 19.626C1.49422 18.746 1 17.5527 1 16.3083C1 15.064 1.49422 13.8706 2.37398 12.9906L6.35522 9.00939C7.23521 8.12963 8.42859 7.63541 9.67292 7.63541C10.9172 7.63541 12.1106 8.12963 12.9906 9.00939",
    stroke: "#173F5F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.3646L12.9906 2.37398C13.8706 1.49422 15.064 1 16.3083 1C17.5527 1 18.746 1.49422 19.626 2.37398C20.5058 3.25397 21 4.44735 21 5.69168C21 6.93601 20.5058 8.12939 19.626 9.00938L15.6448 12.9906C14.7648 13.8704 13.5714 14.3646 12.3271 14.3646C11.0828 14.3646 9.88939 13.8704 9.0094 12.9906",
    stroke: "#173F5F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a81dc01880241f716092130e598b2d33.svg";
export { ForwardRef as ReactComponent };